import React from 'react';
import { Button } from 'react-bootstrap';

const ActionsMenu = (props) => {
    const onItemClick = (key) => {
        if (props.onItemClick) {
            props.onItemClick(key);
        }
    }

    if (props.actions?.length > 0) {
        return <div className={'actions-menu' + (props.className ? ` ${props.className}` : '')}>
            <div className='actions-menu-items'>
                {props.actions?.map(action =>
                    <Button className={action.type} key={action.type} onClick={() => onItemClick(action.type)} disabled={props.disabled} >{action.title}</Button>
                )}
            </div>
        </div>
    }
    return <></>
}
export default ActionsMenu;